import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

const consulta = (endpoint, { empresaId, personaId }, opciones) =>
  _Componentes_WebApiCalls_Post(`CuentaCorriente/${endpoint}`, {
    EmpresaId: Number(empresaId),
    PersonaId: Number(personaId),
  }, opciones);

export const obtenerResumenCuentaCorriente = (request, opciones) => consulta("Resumen", request, opciones);
export const obtenerComprobantesCuentaCorriente = (request, opciones) => consulta("Comprobantes", request, opciones);
export const obtenerImputacionesCuentaCorriente = (request, opciones) => consulta("Imputaciones", request, opciones);

export const imputarCuentaCorriente = ({ empresaId, documentoCreditoId, documentoDebitoId, importe, claveIdempotencia, pcId }, opciones) =>
  _Componentes_WebApiCalls_Post("CuentaCorriente/Imputar", {
    EmpresaId: Number(empresaId),
    DocumentoCreditoId: Number(documentoCreditoId),
    DocumentoDebitoId: Number(documentoDebitoId),
    Importe: Number(importe),
    ClaveIdempotencia: String(claveIdempotencia || ""),
    PcId: Number(pcId),
  }, opciones);

export const revertirImputacionCuentaCorriente = ({ empresaId, imputacionId, motivo, pcId }, opciones) =>
  _Componentes_WebApiCalls_Post("CuentaCorriente/Revertir", {
    EmpresaId: Number(empresaId),
    ImputacionId: Number(imputacionId),
    Motivo: String(motivo || "").trim(),
    PcId: Number(pcId),
  }, opciones);
